import { render, staticRenderFns } from "./BrandingForm.vue?vue&type=template&id=4d338a5c"
import script from "./BrandingForm.vue?vue&type=script&lang=js"
export * from "./BrandingForm.vue?vue&type=script&lang=js"
import style0 from "./BrandingForm.vue?vue&type=style&index=0&id=4d338a5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports